<!--课程码列表-->
<template>
    <a-spin :spinning="spinning">
        <a-table :columns="tableColumns"
                 :row-key="(text, index) => String(text.id) + index"
                 :scroll="{y: 350}"
                 :pagination="table.tablePagination"
                 :loading="table.tableLoading"
                 :locale="table.locale"
                 :dataSource="table.tableDataSource">
            <span slot="gradeClass" slot-scope="text">{{text.gradeName + text.className}}</span>
            <div slot="action" slot-scope="text">
                <a @click="copy(text.userCourseCode)" style="margin-right: 8px">
                    <a-icon type="edit"/>
                    复制</a>
            </div>
        </a-table>
        <div>
            <a-button icon="file-excel" :loading="exportLoading" type="primary" @click="exportCode">导出Excel</a-button>
        </div>
    </a-spin>

</template>

<script>
    import XLSX from 'xlsx'
    import {tableRelevant} from "@/pages/projectImpl/js/utils";

    const tableColumns = [
        {
            title: '课程',
            dataIndex: 'courseName',
        },
        {
            title: "类型",
            dataIndex: 'codeTypeName',
        }, {
            title: "年级/班级",
            scopedSlots: {customRender: 'gradeClass'}
        }, {
            title: "学生",
            dataIndex: 'realName',
        },
        {
            title: "课程码",
            dataIndex: "userCourseCode"
        },
        {
            title: '操作',
            key: "5",
            scopedSlots: {customRender: 'action'}
        }
    ];

    const tableColumns1 = [
        {
            title: "学生",
            dataIndex: 'realName',
        },
        {
            title: '课程',
            dataIndex: 'courseName',
        },
        {
            title: "类型",
            dataIndex: 'codeTypeName',
        }, {
            title: "对象",
            dataIndex: 'obj',
        },
        {
            title: "课程码",
            dataIndex: "userCourseCode"
        },
        {
            title: '操作',
            scopedSlots: {customRender: 'action'}
        }
    ];

    export default {
        name: "CourseCodePage",
        props: {
            //课程码接口请求参数
            params: Object,
            //是否显示导出课程码
            exportExcel: Boolean,
            //课程码类型
            codeType: Number,
        },
        data() {
            return {
                spinning: false,
                tableColumns: tableColumns,
                table: tableRelevant.call(this),
                exportLoading: false,
            }
        },
        created() {
            if (this.codeType !== 3) {
                this.tableColumns = tableColumns1;
            }
            this.getPageList();
        },
        methods: {
            getPageList() {
                this.table.tableLoading = true;
                console.log(this.params);
                const params = {
                    "Parameter.ProjectCourseConfigId": this.params.projectCourseConfigId,
                    "Parameter.ClassUserId": this.params.classUserId,
                    "Parameter.OrganizationUserId": this.params.organizationUserId,
                    "Parameter.codeType": this.codeType,
                    "Parameter.OrganizationId": sessionStorage.getItem("ORGANIZATION_ID"),
                    pageIndex: this.table.tablePagination.current,
                    pageSize: this.table.tablePagination.pageSize
                };
                this.$http.UserManage.getCourseCodeList(params).then(res => {
                    const {data} = res;
                    this.table.tableDataSource = data.items.map(m => ({...m, obj: m.gradeName + m.className}));
                    this.table.tablePagination.total = data.totalCount;
                    this.table.tablePagination.current = data.pageIndex;
                    this.$emit('effectDate', data.items[0].effctDate);
                    console.log(data.totalCount);
                }).finally(() => {
                  this.table.tableLoading = false;
                })
            },
            copy(val) {
                this.$message.destroy();
                try {
                    if (window.clipboardData) {
                        window.clipboardData.setData('text', val);
                    } else {
                        (function (s) {
                            document.oncopy = function (e) {
                                e.clipboardData.setData('text', s);
                                e.preventDefault();
                                document.oncopy = null;
                            }
                        })(val);
                        document.execCommand('Copy');
                    }
                    this.$message.success("复制成功");
                } catch (e) {
                    this.$message.error("复制失败，请手动复制！");
                }
            },
            // 学生码
            exportEx(){
                this.exportLoading = true;
                this.$http.UserManage.getCourseCodeList({
                    "Parameter.codeType": this.codeType,
                    "Parameter.ProjectCourseConfigId": this.params.projectCourseConfigId,
                    "Parameter.OrganizationId": sessionStorage.getItem("ORGANIZATION_ID"),
                    pageIndex: 1,
                    pageSize: 9999,
                    'Parameter.OrganizationUserId':this.params.organizationUserId
                }).then(res => {
                    const {data} = res;
                    const header = ['课程名称', '学生','性别','班级','出生日期', '课程码'];
                    const excelData = [header, ...data.items.map(v => {
                        return [
                            v.courseName,
                            v.realName,
                            v.gender === 1 ? '男' : '女',
                            v.gradeName + v.className,
                            v.birthday,
                            v.userCourseCode
                        ]
                    })];
                    const aoa = XLSX.utils.aoa_to_sheet(excelData)
                    const book = XLSX.utils.book_new()
                    XLSX.utils.book_append_sheet(book, aoa, '第一页')
                    XLSX.writeFile(book, `${data.items[0].courseName}课程码.xlsx`)
                }).finally(() => {
                  this.exportLoading = false;
                })
            },
            // 班级码
            exportCode(){
                if (this.codeType !== 1){
                    this.exportEx()
                    return
                }
                this.exportLoading = true;
                this.$http.UserManage.getCourseCodeList({
                    "Parameter.codeType": this.codeType,
                    "Parameter.ProjectCourseConfigId": this.params.projectCourseConfigId,
                    "Parameter.OrganizationId": sessionStorage.getItem("ORGANIZATION_ID"),
                    pageIndex: 1,
                    pageSize: 9999,
                }).then(res => {
                    const {data} = res;
                    const newArr = data.items.filter((ele, i, self) => {
                        const index = self.findIndex(item => {
                            return item.id === ele.id
                        })
                        return index === i
                    })
                    const arr = [['课程名称', '班级', '课程码']]
                    newArr.forEach(f => {
                        arr.push([
                            f.courseName,
                            f.gradeName + f.className,
                            f.userCourseCode
                        ])
                    })
                    const aoa = XLSX.utils.aoa_to_sheet(arr)
                    const book = XLSX.utils.book_new()
                    XLSX.utils.book_append_sheet(book, aoa, '第一页')
                    XLSX.writeFile(book, `${data.items[0].courseName}课程码.xlsx`)
                }).finally(() => {
                  this.exportLoading = false;
                })
            },
        }
    }
</script>

<style scoped>

</style>
